import { useSelector } from 'react-redux';

import { DEFAULT_UNITS_BY_PREFERRED_SYSTEM } from 'constants/unitOfMeasure';

import { usePreferredUnitSystem } from 'utils/measurement/hooks';

import SelectorCumulativeInfoComponent from '../components/SelectorCumulativeInfoComponent';
import {
  getDimensionalPrecision,
  getDisplayScale,
  getIsMeasurementToolActive,
  getNativeUnits,
  getSelectorCumulativeInfo,
} from '../data/reducer';

const SelectorCumulativeInfo = ({ isEnabled }: { isEnabled: boolean }) => {
  const cumulativeInfo = useSelector(getSelectorCumulativeInfo);
  const displayScale = useSelector(getDisplayScale);
  const isMeasurementToolActive = useSelector(getIsMeasurementToolActive);
  const nativeUnits = useSelector(getNativeUnits);
  const dimensionalPrecision = useSelector(getDimensionalPrecision);

  const { preferredUnitSystem } = usePreferredUnitSystem();
  const displayUnits = DEFAULT_UNITS_BY_PREFERRED_SYSTEM[preferredUnitSystem];

  return isEnabled && !isMeasurementToolActive ? (
    <SelectorCumulativeInfoComponent
      cumulativeInfo={cumulativeInfo}
      displayScale={displayScale}
      displayUnits={displayUnits}
      nativeUnits={nativeUnits}
      dimensionalPrecision={dimensionalPrecision}
    />
  ) : null;
};

export default SelectorCumulativeInfo;
